var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-UX-(New)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_New-Update-(Desktop)",
    transform: "translate(-18.000000, -412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-6",
    transform: "translate(0.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(11.500000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finances-Icon",
    transform: "translate(6.710590, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Finances-Icon-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,3 C20.1045696,3 21,3.89543045 21,5 L21,19 C21,20.1045696 20.1045696,21 19,21 L5,21 C3.89543045,21 3,20.1045696 3,19 L3,5 C3,3.89543045 3.89543045,3 5,3 L19,3 Z",
    id: "Finances-Vector-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,7 L10,16 L7,16 L7,7 L10,7 Z",
    id: "Finances-Vector-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,11 L17,16 L14,16 L14,11 L17,11 Z",
    id: "Finances-Vector-1",
    stroke: "#FFFFFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.1f388467a43c523eedfe9763e0fce9bf.svg";
export { ForwardRef as ReactComponent };